import { render, staticRenderFns } from "./InspectionFormListTable.vue?vue&type=template&id=d06e636a"
import script from "./InspectionFormListTable.vue?vue&type=script&lang=js"
export * from "./InspectionFormListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports